import React, { Component } from "react";
import { connect } from "react-redux";
import TableData from "./components/TableData";
import Label from "egov-ui-kit/utils/translationNode";
import ServiceList from "egov-ui-kit/common/common/ServiceList";
import FilterDialog from "./components/FilterDialog";
import PwdDialog from "./components/PwdDialog";
import MenuButton from "egov-ui-framework/ui-molecules/MenuButton";
import { setRoute } from "egov-ui-framework/ui-redux/app/actions";
import { fetchLocalizationLabel } from "egov-ui-kit/redux/app/actions";
import { getTenantId, getLocale } from "egov-ui-kit/utils/localStorageUtils";
import LoadingIndicator from "egov-ui-framework/ui-molecules/LoadingIndicator";
import {getDateFromEpoch} from "egov-ui-kit/utils/commons"
import "./index.css";

class Inbox extends Component {
  state = {
    actionList: [],
    hasWorkflow: false,
    filterPopupOpen: false,
    PwcExpirePopupOpen:false,
    pwdExpiryDateDDMMYYY:""
  };

  componentDidMount = () => {
    const {fetchLocalizationLabel,userInfo,stateInfoById} = this.props
    let  {PasswordResetPopUpDay} = this.props
    const tenantId = getTenantId();
    if(userInfo && userInfo.pwdExpiryDate)
    {
      let pwdExpiryDate = userInfo.pwdExpiryDate.split(' ')
      let pwdExpiryDateDDMMYYY = userInfo.pwdExpiryDate.split(' ')
      let diffDays = 0 
      let PasswordRestRequired = true;
      if(stateInfoById && stateInfoById[0] )
      {
        PasswordResetPopUpDay = stateInfoById[0].PasswordResetPopUpDay;
        PasswordRestRequired = stateInfoById[0].PasswordRestRequired;
      }
      else
      {
        PasswordResetPopUpDay = 5
      }
      if(pwdExpiryDate && pwdExpiryDate[0])
      {
        // let CurrentDate = new Date().getTime()
        //  pwdExpiryDate = this.convertDateToEpoch(pwdExpiryDate[0],"dayend")
        //  pwdExpiryDateDDMMYYY = getDateFromEpoch(pwdExpiryDate)
        // let DayExpire = (pwdExpiryDate - CurrentDate)
        // this.setState({ pwdExpiryDateDDMMYYY: pwdExpiryDateDDMMYYY });
        // this.setState({ PwcExpirePopupOpen: true });
        // if(DayExpire>0 && PasswordRestRequired === true)
        // {
        //    diffDays = ( (pwdExpiryDate- CurrentDate) / (1000 * 60 * 60 * 24) );
        //   if(diffDays<=PasswordResetPopUpDay &&diffDays >0)
        //   {
        //     this.setState({ PwcExpirePopupOpen: true });
        //     this.setState({ pwdExpiryDateDDMMYYY: pwdExpiryDateDDMMYYY });
        //   }
        // }
        // else
        // {
        //    diffDays = ( (CurrentDate- pwdExpiryDate) / (1000 * 60 * 60 * 24) );
        //   if(PasswordResetPopUpDay>0)
        //   {
            
        //     this.setState({ PwcExpirePopupOpen: true });
        //   }
        // }
      }
    }
    fetchLocalizationLabel(getLocale(), tenantId, tenantId);
  }
  convertDateToEpoch = (dateString, dayStartOrEnd = "dayend") => {
    //example input format : "2018-10-02"
    try {
      const parts = dateString.match(/(\d{1,2})-(\d{1,2})-(\d{4})/);
      const DateObj = new Date(Date.UTC(parts[3], parts[2] - 1, parts[1]));
      DateObj.setMinutes(DateObj.getMinutes() + DateObj.getTimezoneOffset());
      if (dayStartOrEnd === "dayend") {
        DateObj.setHours(DateObj.getHours() + 24);
        DateObj.setSeconds(DateObj.getSeconds() - 1);
      }
      return DateObj.getTime();
    } catch (e) {
      return dateString;
    }
  };
 
  componentWillReceiveProps(nextProps) {
    const { menu } = nextProps;
    const workflowList = menu && menu.filter((item) => item.name === "rainmaker-common-workflow");
    //const workflowList = menu && menu.filter((item) => item.name === "booking-services");
    if (workflowList && workflowList.length > 0) {
      this.setState({
        hasWorkflow: true,
      });
    } else {
      this.setState({
        hasWorkflow: false,
      });
    }

    const list = menu && menu.filter((item) => item.url === "card");
    this.setState({
      actionList: list,
    });
  }

  handleClose = () => {
    this.setState({ filterPopupOpen: false });
  };
  handlesetPwd  = () => {
      this.props.setRoute("/user/change-password");
  }
  handleCloseP = () => {
    this.setState({ PwcExpirePopupOpen: false });
   // this.props.setRoute("/user/change-password");
  };

  onPopupOpen = () => {
    this.setState({ filterPopupOpen: true });
  }

  render() {
    const { name, history, setRoute, menu,Loading } = this.props;
    const { actionList, hasWorkflow } = this.state;
    const a = menu ? menu.filter(item => item.url === "quickAction") : [];
    const downloadMenu = a.map((obj, index) => {
      return {
        labelName: obj.displayName,
        labelKey: `ACTION_TEST_${obj.displayName.toUpperCase().replace(/[._:-\s\/]/g, "_")}`,
        link: () => setRoute(obj.navigationURL)
      }
    })
    const {isLoading}=Loading;
    const buttonItems = {
      label: { labelName: "Take Action", labelKey: "INBOX_QUICK_ACTION" },
      rightIcon: "arrow_drop_down",
      props: { variant: "outlined", style: { marginLeft: 5, marginRight: 15, backgroundColor: "#FE7A51", color: "#fff", border: "none", height: "60px", width: "250px" } },
      menu: downloadMenu
    }
        
    return (
      <div>
        <div className="rainmaker-topHeader" style={{ marginTop: 15, justifyContent: "space-between" }}>
        {Loading&&isLoading&&<LoadingIndicator></LoadingIndicator>}
          <div className="rainmaker-topHeader flex">
            <Label className="landingPageHeader flex-child" label={"CS_LANDING_PAGE_WELCOME_TEXT"} />
            <Label className="landingPageUser flex-child" label={name} />
          </div>
          {/* <div className="quick-action-button">
            <MenuButton data={buttonItems} />
          </div> */}
        </div>
        <div className={"inbox-service-list"}>
          <ServiceList history={history} />
        </div>

        {hasWorkflow && <TableData onPopupOpen={this.onPopupOpen} />}
        <FilterDialog popupOpen={this.state.filterPopupOpen} popupClose={this.handleClose} />
        <PwdDialog 
        popupOpen={this.state.PwcExpirePopupOpen} 
        pwdExpiryDateDDMMYYY={this.state.pwdExpiryDateDDMMYYY}
        popupClose={this.handleCloseP}  popupSet={this.handlesetPwd} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth, app ,screenConfiguration,common} = state;
  const { menu } = app;
  const { userInfo } = auth;
  const name = auth && userInfo.name;
  const { preparedFinalObject } = screenConfiguration;
  const { Loading={}} = preparedFinalObject;
  const {isLoading}=Loading;
  const {stateInfoById}=common;
  //common.stateInfoById
  return { name, menu ,Loading,isLoading,stateInfoById};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setRoute: url => dispatch(setRoute(url)),
    fetchLocalizationLabel: (locale,tenantId,module) => dispatch(fetchLocalizationLabel(locale,tenantId,module)),
  };
}

export default connect(
  mapStateToProps, mapDispatchToProps
)(Inbox);



// WEBPACK FOOTER //
// ./src/modules/employee/Inbox/index.js